import React, { useState } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { makeStyles } from "@mui/styles";
import { useMediaQuery } from "@mui/material";
import Steppers from "./Stepper";


const OrderDetailInfo = ({ ondcOrder, orderState }) => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const classes = useStyles(isSmallScreen);

  const [copiedItem, setCopiedItem] = useState(null); 

  const formatAddress = (address) => {
    const { name, building, locality, city, state, area_code } = address;
    return `${name}, ${building}, ${locality}, ${city}, ${state} - ${area_code}`;
  };

  const handleCopy = (text, item) => {
    navigator.clipboard.writeText(text);
    setCopiedItem(item); 
    setTimeout(() => setCopiedItem(null), 2000); 
  };

  const renderCopyIcon = (item) =>
    copiedItem === item ? (
      <CheckCircleOutlineIcon fontSize="small" color="success" />
    ) : (
      <ContentCopyIcon fontSize="small" />
    );

  return (
    <Card
      className={classes.container}
      elevation={1}
      sx={{
        boxShadow: 7,
        borderRadius: 2,
        margin: 1,
      }}
    >
      <Box
        className={`${classes.root} ${
          isSmallScreen ? classes.column : classes.row
        }`}
      >
        <Box className={classes.detailBox}>
          <CardContent sx={{ textAlign: "left" }}>
            <Chip className={classes.orderStateChip} label={orderState} />
            {!ondcOrder.selfDelivery && ondcOrder.pickupConfirmationCode && (
              <Typography
                variant="caption"
                color="text.secondary"
                component="div"
                className={classes.typography}
              >
                PCC Code: {ondcOrder.pickupConfirmationCode}
              </Typography>
            )}

            {!ondcOrder.selfDelivery && ondcOrder.awb && (
              <Typography
                variant="caption"
                color="text.primary"
                component="div"
                className={classes.typographyWrap}
              >
                AWB: {ondcOrder.awb}
              </Typography>
            )}

            {ondcOrder.selfDelivery && ondcOrder.shippingDetail && (
              <Box sx= {{ marginTop: 1}}>
               <Typography
               variant="subtitle1"
               fontWeight={5}
               //color="text.primary"
               component="div"
               className={classes.typography}
             >
               Customer Contact
             </Typography>

             <Typography
                variant="subtitle2"
                color="text.primary"
                component="div"
                className={classes.typographyWrap}
              >
                {ondcOrder.shippingDetail.customerPhone}
                <IconButton
                  size="small"
                  onClick={() =>
                    handleCopy(
                      ondcOrder.shippingDetail.customerPhone,
                      "customerPhone"
                    )
                  }
                >
                  {renderCopyIcon("customerPhone")}
                </IconButton>
              </Typography>
             </Box>
            )}
          </CardContent>

          {/* Agent Details */}
          {!ondcOrder.selfDelivery && (
            <CardContent sx={{ textAlign: "left" }}>
              <Typography
                variant="subtitle1"
                color="text.primary"
                component="div"
                className={classes.typography}
              >
                Agent Name
              </Typography>
              <Typography
                variant="subtitle2"
                color="text.primary"
                component="div"
                className={classes.typographyWrap}
              >
                {ondcOrder.agentName ? (
                  ondcOrder.agentName
                ) : (
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    component="span"
                    sx={{ fontStyle: "italic" }}
                  >
                    Unassigned 
                  </Typography>
                )}
              </Typography>
            </CardContent>
          )}

          {!ondcOrder.selfDelivery && (
            <CardContent sx={{ textAlign: "left" }}>
              <Typography
                variant="subtitle1"
                color="text.primary"
                component="div"
                className={classes.typography}
              >
                Agent Phone
              </Typography>
              <Typography
                variant="subtitle2"
                color="text.primary"
                component="div"
                className={classes.typographyWrap}
              >
                {ondcOrder.agentPhone ? (
                  ondcOrder.agentPhone
                ) : (
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    component="span"
                    sx={{ fontStyle: "italic" }}
                  >
                    Unassigned 
                  </Typography>
                )}
              </Typography>
            </CardContent>
          )}

          {/* Delivery Address */}
          {ondcOrder.selfDelivery && ondcOrder.shippingDetail.address && (
            <CardContent sx={{ textAlign: "left" }}>
              <Typography
                variant="subtitle1"
                color="text.primary"
                component="div"
                className={classes.typography}
              >
                Delivery Address
              </Typography>
              <Typography
                variant="subtitle2"
                color="text.primary"
                component="div"
              >
                {formatAddress(ondcOrder.shippingDetail.address)}
                <IconButton
                  size="small"
                  onClick={() =>
                    handleCopy(
                      formatAddress(ondcOrder.shippingDetail.address),
                      "deliveryAddress"
                    )
                  }
                >
                  {renderCopyIcon("deliveryAddress")}
                </IconButton>
              </Typography>
            </CardContent>
          )}
        </Box>

        <Box className={classes.stepper}>
          <Steppers
            orderStatus={orderState}
            selfDelivery={ondcOrder?.selfDelivery}
          />
        </Box>
      </Box>
    </Card>
  );
};

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    padding: "1vh",
    justifyContent: "center",
  },
  root: {
    display: "flex",
    width: "100%",
  },
  detailBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  orderStateChip: {
    align: "flex-start",
    color: "text.primary",
    fontWeight: "bold",
  },
  column: {
    flexDirection: "column",
  },
  row: {
    flexDirection: "row",
  },
  typography: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontWeight: "bold",
  },
  stepper: {
    flex: "1",
    display: "flex",
    alignItems: "center",
  },
  typographyWrap: {
    whiteSpace: "normal", // Allows text to wrap
    wordBreak: "break-word", // Breaks long words
  },
}));

export default OrderDetailInfo;
